import { BrowserRouter, Routes, Route } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
import Navbar from "./components/Navbar/Navbar.jsx";
import Footer from "./components/Footer/Footer.jsx";

import Home from "./pages/Home/home.jsx";
import About from "./pages/About/about.jsx";
import Contact from "./pages/Contact/contact.jsx";
import Services from "./pages/Services/services.jsx";
import ServiceDetails from "./pages/ServiceDetails/ServiceDetails.jsx";
import IssueDetails from "./pages/IssueDetails/IssueDetails.jsx";

import FloatingWhatsApp from "./components/FloatingWhatsApp/FloatingWhatsApp";

import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

function App() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      offset: 100,
    });
  }, []);

  return (
    <BrowserRouter>
      <ScrollToTop />

      <Navbar />

      <FloatingWhatsApp />

      <Routes>
        {/* Main Pages */}
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/contact" element={<Contact />} />

        {/* Service Detail Pages */}
        <Route
          path="/services/:slug"
          element={<ServiceDetails />}
        />

        <Route path="/issues/:slug" element={<IssueDetails />} />
      </Routes>

      <Footer />
    </BrowserRouter>
  );
}

export default App;